import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import MainContent from '../MainContent.js';
import CalendarForm from '../forms/CalendarForm.js';
import i18next from '../../i18n.js';
import { Form, Button } from 'react-bootstrap';
import ItemsForPeriodWidget from '../widgets/ItemsForPeriodWidget.js';
import { listTypes, urls, UserContext, backgroundTypes } from '../../constants.js';
import { loadListData } from '../helpers/HelperFunctions.js';
import moment from 'moment';
import { BackgroundContainer } from '../account/BackgroundContaner.js';

const CalendarPage = () => {
    const months = Array.from({ length: 12 }, (_, i) => i);
    const [yearList, setYearList] = useState(null);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth());
    const [showVacations, setShowVacations] = useState(true);
    const [vacations, setVacations] = useState(null);
    const fetchResults = useRef({});
    const userData = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        const yList = [];
        let startYear = 2024;
        const currentYear = new Date().getFullYear();
        while (startYear <= currentYear + 1) {
            yList.push(startYear);
            startYear++;
        }
        setYearList(yList);
    }, []);

    useEffect(() => {
        if (fetchResults.current[year]) {
            setVacations(fetchResults.current[year]);
        }
        else {
            const filter = [
                {
                    name: 'Creator',
                    values: ['ME']
                },
                {
                    name: 'ClaimDateStart',
                    values: ['1991-01-01', `${year}-12-31`]
                },
                {
                    name: 'ClaimDateEnd',
                    values: [`${year}-01-01`, '2091-01-01']
                }];

            loadListData(listTypes.Documents, filter, 0, 10000).then(data => {
                if (data && data.items) {
                    setVacations(data.items);
                    fetchResults.current[year] = data.items;
                }
            });
        }
    }, [year]);

    const onYearChanged = (e) => setYear(e.target.value);
    const onMonthChanged = (e) => setMonth(e.target.value);

    const onVacationSowChanged = (show) => setShowVacations(show);
    const onScheduleBtnClick = () => navigate(urls.schedulePage);

    const filterVacations = () => {
        const monthValue = parseInt(month);
        if (monthValue && vacations) {
            const firstMonthDate = new Date(year, monthValue, 1);
            const lastMonthDate = new Date(year, monthValue + 1, 0);
            return vacations.filter(v => {
                const startDate = moment(v.fields.find(f => f.name === 'ClaimDateStart').value, 'DD.MM.YYYY').toDate();
                const endDate = moment(v.fields.find(f => f.name === 'ClaimDateEnd').value, 'DD.MM.YYYY').toDate();
                return startDate <= lastMonthDate && endDate >= firstMonthDate;
            });
        }
        return vacations;
    }

    return <BackgroundContainer type={backgroundTypes.general} >
        <MainContent key="main-content">
            <div className='calendar-page'>
                <div className='calendar-page-title'>{i18next.t('calendar.pageTitle')}</div>
                <div className='calendar-filter'>
                    {yearList &&
                        <div className='select'>
                            <Form.Select value={year} onChange={onYearChanged} className='year-select' >
                                {yearList.map((val) => <option key={val} value={val}>{val}</option>)}
                            </Form.Select>
                        </div>
                    }
                    <div className='select'>
                        <Form.Select value={month ?? ''} onChange={onMonthChanged} >
                            <option value='' >{i18next.t(`calendar.allMonths`)}</option>
                            {months.map((val) => <option key={val} value={val} >{i18next.t(`calendar.months.${val}`)}</option>)}
                        </Form.Select>
                    </div>
                </div>
                {userData.isHead && <Button variant="secondary arrow schedule-btn" onClick={onScheduleBtnClick}>{i18next.t("calendar.scheduleBtnText")}</Button>}
                <ItemsForPeriodWidget type={listTypes.Documents} checked={showVacations} items={filterVacations()} onCheckChanged={onVacationSowChanged} />
                <CalendarForm year={year} month={month} showVacations={showVacations} vacations={vacations} />
            </div>
        </MainContent>
    </BackgroundContainer>
}

export default CalendarPage;